<template>
	<svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg">
<!--        <rect :width="width" :height="height" :rx="height / 2" fill="#C7C7C7" fill-opacity="0.03" :class="{'tw-hidden': speaking }"/>-->
<!--        <rect :x="width * 0.105" :y="width * 0.105" :width="width * 0.79" :height="height * 0.79" :rx="width * 0.79 / 2" fill="#C7C7C7" fill-opacity="0.17" :class="{'tw-hidden': speaking }" />-->
		<rect :x="width * 0.2" :y="width * 0.2" :width="width * 0.6" :height="width * 0.6" :rx="width * 0.6 / 2" fill="#C7C7C7" fill-opacity="0.17"  :class="{'stroke-green': speaking}"/>
		<text class="pulse-text" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" :class="{'!tw-opacity-100': speaking}">{{ first_letter }}</text>
	</svg>
</template>

<script>
export default {
	name: "Pulse.vue",
	props: {
		first_letter: {
			required: true,
			default: 'A'
		},
        static: {
            required: true,
            default: false,
        },
        speaking: {
            default: false,
        },
        width: {
            default: 185,
        },
        height: {
            default: 185
        }
	},
}
</script>

<style scoped>
.pulse-text {
	font-size: 3.75rem;
	font-weight: 600;
	fill: white;
    opacity: 0.6;
	text-transform: uppercase;
	transform: translateY(3px);
    user-select: none;
}

.stroke-green {
    stroke: #00E89C;
    /*animation: 1000ms ease;*/
}

.grow-outer-circle {
    animation: grow-outer 1000ms ease-in-out infinite forwards;
    -moz-animation: grow-outer 1000ms ease-in-out infinite forwards;
    -o-animation: grow-outer 1000ms ease-in-out  infinite forwards;
    -webkit-animation: grow-outer 1000ms ease-in-out  infinite forwards;
    transform-origin: 50% 50%;
}

.grow-middle-circle {
    animation:grow-middle 1000ms ease-in-out infinite forwards;
    -moz-animation: grow-middle 1000ms ease-in-out infinite forwards;
    -o-animation: grow-middle 1000ms ease-in-out infinite forwards;
    -webkit-animation: grow-middle 1000ms ease-in-out  infinite forwards;
    transform-origin: 50% 50%;
}

.grow-inner-circle {
    animation:grow-inner 1000ms ease-in-out infinite forwards;
    -moz-animation: grow-inner 1000ms ease-in-out infinite forwards;
    -o-animation: grow-inner 1000ms ease-in-out  infinite forwards;
    -webkit-animation: grow-inner 1000ms ease-in-out  infinite forwards;
    transform-origin: 50% 50%;
}

@keyframes grow-outer {
    0% {
        -webkit-transform: scale( 1 );
        -moz-transform: scale( 1 );
        -o-transform: scale( 1 );
        -ms-transform: scale( 1 );
        transform: scale( 1 );
    }

    50% {
        -webkit-transform: scale( 0.75 );
        -moz-transform: scale( 0.75 );
        -o-transform: scale( 0.75);
        -ms-transform: scale( 0.75 );
        transform: scale( 0.75 );
        fill-opacity: 0.03;
    }

    100% {
        -webkit-transform: scale( 1 );
        -moz-transform: scale( 1 );
        -o-transform: scale( 1 );
        -ms-transform: scale( 1 );
        transform: scale( 1 );
    }
}

@keyframes grow-middle {
    0% {
        -webkit-transform: scale( 1 );
        -moz-transform: scale( 1 );
        -o-transform: scale( 1 );
        -ms-transform: scale( 1 );
        transform: scale( 1 );
    }

    50% {
        -webkit-transform: scale( 0.85 );
        -moz-transform: scale( 0.85 );
        -o-transform: scale( 0.85);
        -ms-transform: scale( 0.85 );
        transform: scale( 0.85 );
        fill-opacity: 0.17;
    }

    100% {
        -webkit-transform: scale( 1 );
        -moz-transform: scale( 1 );
        -o-transform: scale( 1 );
        -ms-transform: scale( 1 );
        transform: scale( 1 );
    }
}

@keyframes grow-inner {
    0% {
        -webkit-transform: scale( 1 );
        -moz-transform: scale( 1 );
        -o-transform: scale( 1 );
        -ms-transform: scale( 1 );
        transform: scale( 1 );
    }

    50% {
        -webkit-transform: scale( 0.95 );
        -moz-transform: scale( 0.95 );
        -o-transform: scale( 0.95);
        -ms-transform: scale( 0.95 );
        transform: scale( 0.95 );
        fill-opacity: 0.24;
    }

    100% {
        -webkit-transform: scale( 1 );
        -moz-transform: scale( 1 );
        -o-transform: scale( 1 );
        -ms-transform: scale( 1 );
        transform: scale( 1 );
    }
}
</style>
